import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import {Application} from "../application";
import * as ko from "knockout";

export class LogOutCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.LogOut;
    canExecute = ko.computed(() => {
        return true;
    });
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    execute(): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        let identityServer = this.getMeta('tne.identity.server');

        this.app.logOut();
        
        return $.Deferred().resolve().promise();
    }

    name = "Log Out";

    getMeta(metaName: string) {
        const metas = document.getElementsByTagName('meta');

        for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') === metaName) {
                return metas[i].getAttribute('content');
            }
        }

        return '';
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/logOutCommand.ts